// extracted by mini-css-extract-plugin
export var actionButton = "_6b-1";
export var actionButtons = "_6b-2";
export var actions = "_6b-0";
export var aiUnread = "_6b-10";
export var alignCenter = "_6b-h";
export var backWrapper = "_6b-3";
export var cellContainer = "_6b-4";
export var checkboxContainer = "_6b-5";
export var contentContainer = "_6b-6";
export var contentHeader = "_6b-8";
export var conversationsTableWrapper = "_6b-s";
export var draftReplyBadgeContainer = "_6b-m";
export var dropdownItem = "_6b-b";
export var dropdownItemsContainer = "_6b-a";
export var dropdownTitle = "_6b-c";
export var errorIcon = "_6b-7";
export var filter = "_6b-d";
export var gray = "_6b-i";
export var headerActionButtons = "_6b-e";
export var headerCheckboxContainer = "_6b-f";
export var icon = "_6b-j";
export var menuContainer = "_6b-k";
export var noMoreTicketsIcon = "_6b-12";
export var noMoreTicketsSubText = "_6b-13";
export var oneLine = "_6b-l";
export var optionsButton = "_6b-n";
export var plus = "_6b-o";
export var portalButtonsWrapper = "_6b-g";
export var red = "_6b-p";
export var scrolledTop = "_6b-9";
export var search = "_6b-q";
export var selectedConversationsCount = "_6b-r";
export var spinner = "_6b-t";
export var strong = "_6b-u";
export var summaryCell = "_6b-v";
export var tableContainer = "_6b-11";
export var tagContainer = "_6b-w";
export var threeDots = "_6b-x";
export var twoLines = "_6b-y";
export var unread = "_6b-z";